import { QuantityInput } from '../../prescription/quantity/QuantityInput';
import { Quantity } from '../../prescription/quantity/quantity.types';
import { DraftPrescriptionFieldName, DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

type DraftStandardPrescriptionQuantitySlotProps = Pick<DraftPrescriptionsFormController, 'register' | 'trigger'> & {
   readonly name: DraftPrescriptionFieldName;
   readonly defaultValue: Quantity | null;
   readonly extendedDosageActive: boolean;
   readonly packagesCountEditable: boolean;
   readonly dosageExceedingPackages: boolean;
};

export const DraftStandardPrescriptionQuantitySlot = (
   props: DraftStandardPrescriptionQuantitySlotProps
): JSX.Element => {
   const packagesCountComputed = props.extendedDosageActive && !props.packagesCountEditable;

   return (
      <QuantityInput
         register={props.register}
         trigger={props.trigger}
         name={props.name}
         defaultValue={props.defaultValue}
         dosageExceedingPackages={props.extendedDosageActive ? false : props.dosageExceedingPackages}
         disabled={packagesCountComputed}
      />
   );
};
